import CurrencyFormat from 'react-currency-format';
import { Button, Col, Container, Content, ControlLabel, FlexboxGrid, FormGroup, Modal, Table } from 'rsuite';

const { Column, HeaderCell, Cell, Pagination } = Table;

const ModalProdutoPrecificacao = ({ isOpen, tabelaData, headerData, onClose, onChangePage, onChangeLength, paginationData }) => (
  <Modal style={{ width: '992px', height: '646px' }} show={isOpen} onHide={onClose} className="modal-family-precificacao">
    <Container className="modal-family-precificacao">
      <Modal.Header>
        <Modal.Title>{`Familia ${headerData?.product_family_id || ''}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Content>
          <FlexboxGrid className="cabecalho">
            <FlexboxGrid.Item componentClass={Col} lg={5} md={5} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label">FAMÍLIA DE PRODUTOS</ControlLabel>
                <p className="list__modal-label">
                  <strong>{headerData.product_family_id}</strong>
                </p>
              </FormGroup>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={19} md={5} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label">TOTAL DE PRODUTOS</ControlLabel>
                <p className="list__modal-label">{headerData.count}</p>
              </FormGroup>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item componentClass={Col} lg={5} md={3} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label-niveis">PMZ</ControlLabel>
                <p className="list__modal-label-niveis">
                  {headerData.pmz ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={headerData.pmz}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </p>
              </FormGroup>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={4} md={3} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label-niveis">PREÇO VIGENTE</ControlLabel>
                <p className="list__modal-label-niveis">
                  {headerData.retail_price ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={headerData.retail_price}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </p>
              </FormGroup>
            </FlexboxGrid.Item>

            <FlexboxGrid.Item componentClass={Col} lg={5} md={3} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label-niveis">MÉDIA CONCORRÊNCIA</ControlLabel>
                <p className="list__modal-label-niveis">
                  {headerData.competitor_price ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={headerData.competitor_price}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </p>
              </FormGroup>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={4} md={3} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label-niveis">COMPETITIVIDADE</ControlLabel>
                <p className="list__modal-label-niveis">
                  {headerData.competitiveness ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={headerData.competitiveness}
                      displayType="text"
                      suffix="%"
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </p>
              </FormGroup>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={3} md={3} sm={24} xs={24}>
              <FormGroup>
                <ControlLabel className="description__modal-label-niveis">MARGEM</ControlLabel>
                <p className="list__modal-label-niveis">
                  {headerData.margin ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={headerData.margin}
                      displayType="text"
                      suffix="%"
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )}
                </p>
              </FormGroup>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Content>
        <Content>
          <Table data={tabelaData} className="tabela" autoHeight>
            <Column flexGrow={4}>
              <HeaderCell>Produto</HeaderCell>
              <Cell>
                {rowData => {
                  const codigoproduto = [...(rowData.product_id?.length ? [rowData.product_id] : [])];

                  const descricaoproduto = [...(rowData.description?.length ? [rowData.description] : [])];
                  return (
                    <span>
                      {codigoproduto?.length ? <strong>{codigoproduto}</strong> : null} - {descricaoproduto}
                    </span>
                  );
                }}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>PMZ</HeaderCell>
              <Cell className="grid__tabel-modal">
                {rowData =>
                  rowData.pmz ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={rowData.pmz}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )
                }
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Preço vigente</HeaderCell>
              <Cell className="grid__tabel-modal">
                {rowData =>
                  rowData.retail_price ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={rowData.retail_price}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )
                }
              </Cell>
            </Column>
            <Column width={150}>
              <HeaderCell>Média concorrência</HeaderCell>
              <Cell className="grid__tabel-modal">
                {rowData =>
                  rowData.competitor_price ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={rowData.competitor_price}
                      displayType="text"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )
                }
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Competitividade</HeaderCell>
              <Cell className="grid__tabel-modal">
                {rowData =>
                  rowData.competitiveness ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      decimalScale={2}
                      value={rowData.competitiveness}
                      displayType="text"
                      suffix="%"
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : (
                    '--'
                  )
                }
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Margem</HeaderCell>
              <Cell className="grid__tabel-modal">
                {rowData =>
                  rowData.margin ? (
                    <CurrencyFormat
                      fixedDecimalScale
                      value={rowData.margin}
                      decimalScale={2}
                      displayType="text"
                      suffix="%"
                      decimalSeparator=","
                      thousandSeparator="."
                    />
                  ) : null
                }
              </Cell>
            </Column>
          </Table>
          <Pagination
            showLengthMenu={false}
            activePage={paginationData.number + 1}
            displayLength={paginationData.size}
            total={paginationData.totalElements}
            onChangePage={onChangePage}
            onChangeLength={onChangeLength}
          />
        </Content>
      </Modal.Body>
    </Container>
    <Modal.Footer>
      <Button onClick={onClose} appearance="ghost" className="botao-fechar-modal">
        FECHAR
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalProdutoPrecificacao;
